/**
 * Checks if the user has admin access rights.
 */
const hasAdminAccessRights = (
  isTopUser: boolean | undefined,
  subUserRole: string | undefined
) => {
  return isTopUser || ["Admin", "Supervisor"].includes(subUserRole + "");
};

export default hasAdminAccessRights;
